import React from "react";
import { ServerComponentCaller } from "../../helpers";

const NoOlvidarEstudiarEstoClaseB = (props) => (
  <ServerComponentCaller url={"assets/data/pages/tips/tipsClaseB.json"} />
);

export default NoOlvidarEstudiarEstoClaseB;
